class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.triggerButton = null;
    this.closeButton = null;
    this.returnButton = null;
    this.unitSwitch = null;
    this.currentUnit = "cm";
    this.selectors = {
      table: "table",
      tablePages: "td:first-of-type",
      triggerButton: "#size-chart-button",
      closeButton: "#size-chart-close",
      returnButton: "#size-chart-return",
    };
    this.init();
  }

  init() {
    this.triggerButton = document.querySelector(this.selectors.triggerButton);
    this.closeButton = document.querySelector(this.selectors.closeButton);
    this.returnButton = document.querySelector(this.selectors.returnButton);

    if (this.triggerButton && this.closeButton && this.returnButton) {
      this.buildContent();
      this.startEvents();
    }
  }

  buildContent() {
    const table = this.querySelector(this.selectors.table);
    const tablePages = Array.from(
      table.querySelectorAll(this.selectors.tablePages)
    ).filter((tablePage) => tablePage.textContent.trim() !== "");

    if (tablePages.length > 0) {
      tablePages.forEach((tablePage) => {
        const textHandle = tablePage.textContent
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");

        tablePage.innerHTML = `
                <a href="#" class="size-chart-icon" data-page="${textHandle}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"/>
                        <path d="M12 16v-4M12 8h.01"/>
                    </svg>
                </a>${tablePage.innerHTML}`;
      });
    }

    this.addUnitSwitchControl();
    this.initializeCellDataAttributes();
  }

  addUnitSwitchControl() {
    const table = this.querySelector(this.selectors.table);
    if (table) {
      const firstRow = table.querySelector("tr:first-child");
      if (firstRow) {
        const firstCell = firstRow.querySelector("td:first-child");
        if (firstCell) {
          // Limpiar el contenido del primer td antes de insertar el interruptor
          firstCell.innerHTML = "";

          // Crear el contenedor del interruptor
          const switchContainer = document.createElement("label");
          switchContainer.classList.add("unit-switch");

          // Crear el input checkbox
          const switchInput = document.createElement("input");
          switchInput.type = "checkbox";
          switchInput.id = "unit-switch-input";

          // Crear el span para el deslizador
          const switchSlider = document.createElement("span");
          switchSlider.classList.add("slider");
          switchSlider.setAttribute("data-unit", "cm");

          // Armar el interruptor
          switchContainer.appendChild(switchInput);
          switchContainer.appendChild(switchSlider);

          // Insertar el interruptor en el primer td
          firstCell.appendChild(switchContainer);

          this.unitSwitch = switchInput;

          // Añadir el evento al interruptor
          this.unitSwitch.addEventListener(
            "change",
            this.toggleUnits.bind(this)
          );
        }
      }
    }
  }

  initializeCellDataAttributes() {
    const table = this.querySelector(this.selectors.table);
    if (!table) return;

    const rows = table.querySelectorAll("tr");
    for (let i = 1; i < rows.length; i++) {
      // Saltar la fila de encabezado
      const cells = rows[i].querySelectorAll("td");
      for (let j = 1; j < cells.length; j++) {
        // Saltar la primera columna
        const cell = cells[j];
        const value = cell.textContent.trim().replace(",", ".");
        const numValue = parseFloat(value);
        if (!isNaN(numValue)) {
          cell.dataset.cmValue = numValue;
          cell.dataset.currentValue = numValue;
        }
      }
    }
  }

  startEvents() {
    this.startSizeChartEvents();
    this.startAdditionalEvents();
  }

  startSizeChartEvents() {
    this.triggerButton.addEventListener("click", this.openSizeChart.bind(this));
    this.closeButton.addEventListener("click", this.closeSizeChart.bind(this));
    this.returnButton.addEventListener(
      "click",
      this.closeInstructions.bind(this)
    );
  }

  startAdditionalEvents() {
    const infoButtons = this.querySelectorAll(".size-chart-icon");

    infoButtons.forEach((infoButton) => {
      infoButton.addEventListener("click", this.openInstructions.bind(this));
    });
  }

  openSizeChart(event) {
    event.preventDefault();

    document.body.classList.add("overflow-hidden");
    const header = document.querySelector("#shopify-section-header");
    const headerSiteControl = header.querySelector("#site-control");

    if (headerSiteControl) {
      headerSiteControl.classList.add("z-index-0");
    }

    this.classList.add("active");
  }

  closeSizeChart(event) {
    event.preventDefault();

    document.body.classList.remove("overflow-hidden");
    const header = document.querySelector("#shopify-section-header");
    const headerSiteControl = header.querySelector("#site-control");

    if (headerSiteControl) {
      headerSiteControl.classList.remove("z-index-0");
    }

    this.classList.remove("active");
  }

  openInstructions(event) {
    event.preventDefault();
    let button = event.target;

    if (button.tagName !== "A") {
      button = button.closest("a");
    }

    const content = this.querySelector(".size-chart__content");
    const iconReturn = this.querySelector(".icon-return");
    const footer = this.querySelector(".footer-size-chart");
    const pageName = button.dataset.page.toLowerCase();
    const tableHeading = this.querySelector("#size-chart-table-heading");
    const table = this.querySelector("#size-chart-table");

    const pageContent = Array.from(this.querySelectorAll("[id]")).find(
      (element) => element.id.toLowerCase().includes(pageName)
    );

    if (!pageContent || !tableHeading || !table) {
      return;
    }

    content.classList.add("hidden");
    iconReturn.classList.remove("hidden");
    footer.classList.add("hidden");
    pageContent.classList.add("active");
    tableHeading.classList.add("hide");
    table.classList.add("hide");
  }

  closeInstructions(event) {
    event.preventDefault();
    let button = event.target;

    if (button.tagName !== "BUTTON") {
      button = button.closest("button");
    }

    const content = this.querySelector(".size-chart__content");
    const iconReturn = this.querySelector(".icon-return");
    const footer = this.querySelector(".footer-size-chart");
    const pageContentActive = this.querySelector(`.size-chart__page.active`);
    const tableHeading = this.querySelector("#size-chart-table-heading");
    const table = this.querySelector("#size-chart-table");

    if (!pageContentActive || !tableHeading || !table) {
      return;
    }

    content.classList.remove("hidden");
    iconReturn.classList.add("hidden");
    footer.classList.remove("hidden");
    pageContentActive.classList.remove("active");
    tableHeading.classList.remove("hide");
    table.classList.remove("hide");
  }

  toggleUnits(event) {
    if (this.unitSwitch.checked) {
      this.currentUnit = "inches";
    } else {
      this.currentUnit = "cm";
    }

    this.updateUnitText();
    this.updateTableValues();
  }

  updateUnitText() {
    const switchSlider = this.unitSwitch.nextElementSibling;
    if (this.currentUnit === "cm") {
      switchSlider.setAttribute("data-unit", "cm");
    } else {
      switchSlider.setAttribute("data-unit", "in");
    }
  }

  updateTableValues() {
    const table = this.querySelector(this.selectors.table);
    if (!table) return;

    const rows = table.querySelectorAll("tr");
    for (let i = 1; i < rows.length; i++) {
      // Saltar la fila de encabezado
      const cells = rows[i].querySelectorAll("td");
      for (let j = 1; j < cells.length; j++) {
        // Saltar la primera columna
        const cell = cells[j];
        const cmValue = parseFloat(cell.dataset.cmValue);
        if (!isNaN(cmValue)) {
          let newValue;
          if (this.currentUnit === "inches") {
            newValue = (cmValue / 2.54).toFixed(2);
          } else {
            newValue = cmValue.toFixed(2);
          }
          cell.textContent = newValue;
          cell.dataset.currentValue = newValue;
        }
      }
    }
  }
}

customElements.define("size-chart", SizeChart);
